/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
/** Common Components */
import Buttons from "../../../components/ui/button/Buttons";
import { AppIcons } from "../../../data/appIcons";
import PropTypes from "prop-types";
/** RTK Query */
import {
  useAddRoleMutation,
  useLazyGetRoleByIdQuery,
  useUpdateRoleMutation,
} from "../../../app/services/RoleManagement";
/** Common Services & Data Files */
import ToastService from "../../../services/toastService/ToastService";
import FormCreator from "../../../components/finalForms/FormCreator";
import FormData from "./config/Role.data";

export const AddRoleManagement = (props) => {
  const RoleRef = useRef();
  /* State*/
  const [RoleForm, setRoleForm] = useState(FormData);
  // API'S Call
  const [addRole, {
    isSuccess: isRoleAdded,
    isLoading: isRoleAdding,
    data: addRoleData
  }] = useAddRoleMutation();
  const [getRoleById, {
    isFetching: isGetByIdFetching,
    isSuccess: isGetByIdSuccess,
    data: isGetByIdData
  }] = useLazyGetRoleByIdQuery();
  const [updateRole, {
    isLoading: isRoleUpdating,
    isSuccess: isRoleUpdateSuccess,
    data: isRoleUpdateData
  }] = useUpdateRoleMutation();

  //** useEffect's */
  useEffect(() => {
    formReset();
    if (props.roleId) {
      getRoleById(props.roleId);
    }
  }, [getRoleById]);

  useEffect(() => {
    if (isGetByIdSuccess && !isGetByIdFetching && isGetByIdData) {
      if (isGetByIdData) {
        let RoleData = { ...RoleForm };
        RoleData.initialState = {
          ...RoleForm.initialState,
          roleName: isGetByIdData.roleName,
          roleDescription: isGetByIdData.roleDescription,
          isActive: isGetByIdData.isActive,
        };
        setRoleForm(RoleData);
      }
    }
  }, [isGetByIdData, isGetByIdFetching, isGetByIdSuccess]);

  useEffect(() => {
    if (isRoleUpdateSuccess && isRoleUpdateData) {
      if (isRoleUpdateData.errorMessage.includes("exists")) {
        ToastService.warning(isRoleUpdateData.errorMessage);
        return;
      } else {
        ToastService.success(isRoleUpdateData.errorMessage);
        backToList();
      }
    }
  }, [isRoleUpdateSuccess, isRoleUpdateData]);

  useEffect(() => {
    if (isRoleAdded && addRoleData) {
      if (addRoleData.errorMessage.includes("exists")) {
        ToastService.warning(addRoleData.errorMessage);
        return;
      } else {
        ToastService.success(addRoleData.errorMessage);
        backToList();
      }
    }
  }, [isRoleAdded, addRoleData]);

  //** Funcation's */
  const formReset = () => {
    const projectForm = { ...FormData };
    projectForm.initialState = { ...FormData.initialState };
    setRoleForm(projectForm);
  };

  const handleSubmit = () => {
    let RoleManagementData = RoleRef.current.getFormData();
    if (!props.roleId && RoleManagementData) {
      const requestData = {
        ...RoleManagementData,
        roleName: RoleManagementData.roleName,
        roleDescription: RoleManagementData.roleDescription,
        isActive: RoleManagementData.isActive || false,
      };
      addRole(requestData);
    } else if (props.roleId && RoleManagementData) {
      const requestUpdateData = {
        roleId: props.roleId,
        roleName: RoleManagementData.roleName,
        roleDescription: RoleManagementData.roleDescription,
        isActive: RoleManagementData.isActive,
      };
      updateRole(requestUpdateData);
    }
  };

  const backToList = () => {
    props.onClose();
    formReset();
  };

  return (
    <>
      <FormCreator config={RoleForm} ref={RoleRef} {...RoleForm} />
      <div className="form-btn d-flex justify-content-end">
        <Buttons
          buttonTypeClassName="dark-btn"
          onClick={backToList}
          buttonText="Cancel"
        />
        <Buttons
          buttonTypeClassName="theme-btn ml-4"
          imagePath={AppIcons.AddIcon}
          buttonText={`${props.roleId ? "Update" : "Add"}`}
          onClick={handleSubmit}
          isLoading={isRoleAdding || isRoleUpdating}
        />
      </div>
    </>
  );
};

AddRoleManagement.propTypes = {
  roleId: PropTypes.number,
  onClose: PropTypes.func,
};
export default AddRoleManagement;
